export default __webpack_public_path__ + "static/media/tasksList.d53df0ed.svg";